import React, { useState, useEffect } from 'react';
import Button from '../components/Button';
import '../styles/settings.css';
import { AiFillEye, AiFillEyeInvisible, AiOutlineMenu } from "react-icons/ai";
import axios from 'axios';
import config from '../config';
import Alert from '../components/Alert';
import Sidebar from '../components/Sidebar';
import { RxCross1 } from 'react-icons/rx';

const mainUrl = config.baseurl;

const Setting = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [togglesidebar, setTogglesidebar] = useState(true);
  const [twilioData, setTwilioData] = useState({ account_sid: '', api_key_sid: '', api_key_secret: '' });
  const [configurationData, setConfigurationData] = useState({ jwt_secret: '', encrypt_iv: '', encrypt_key: '' });
  const [readOnly, setReadOnly] = useState(true);
  const [error, setError] = useState({ errorFor: '', message: '' });
  const [showAlert, setShowAlert] = useState({ title: '', message: '', type: '', isShow: false });

  const token = localStorage.getItem('token')

  useEffect(() => {
    const getSettingsData = async () => {
      try {
        const response = await axios({
          method: 'get',
          url: `${mainUrl}/api/getSettings`,
          data: {},
          headers: {
            "content-type": "application/json",
            "authorization": `${token}`
          }
        });
        const data = response.data.data[0];
        console.log('getsettings ', data);
        
        // console.log("twilio " + JSON.stringify(data));
        if(data){
          setTwilioData({
            account_sid: data.integrations.twilio.account_sid,
            api_key_sid: data.integrations.twilio.api_key_sid,
            api_key_secret: data.integrations.twilio.api_key_secret
          })
          setConfigurationData({
            jwt_secret: data.system.jwt_secret,
            encrypt_key: data.system.encrypt_key,
            encrypt_iv: data.system.encrypt_iv,
          })
        }
      }
      catch (error) {
        setShowAlert({ title: "Alert", message: `Please login again`, type: 'danger', isShow: true });
        console.log('apiErrror ' + error);
      }
    }
    getSettingsData();
  }, [])

  const toggleEye = () => {
    setShowPassword(!showPassword);
  }

  const handleInputTwilio = (e) => {
    let length = e.target.value.length;
    let element = document.getElementsByName(e.target.name)[0];
    if (length === 0) {
      element.style.boxShadow = '1px 1px 3px red, -1px -1px 3px red';
      setError({ errorFor: e.target.name, message: 'This field is required!' });
      setTwilioData({ ...twilioData, [e.target.name]: e.target.value });
    }
    if (length > 0) {
      element.style = 'none';
      setError({ errorFor: '', message: '' });
      setTwilioData({ ...twilioData, [e.target.name]: e.target.value });
    }
  }

  const updateTwilio = async () => {
    try {
      const response = await axios({
        method: 'post',
        url: `${mainUrl}/api/updateTwilioSettings`,
        data: {
          account_sid: twilioData.account_sid,
          api_key_sid: twilioData.api_key_sid,
          api_key_secret: twilioData.api_key_secret
        },
        headers: {
          "content-type": "application/json",
          "authorization": `${token}`
        }
      });
      const data = response.data;
      console.log("twilio " + JSON.stringify(data));
      setShowAlert({ title: "Alert", message: `Twilio settings updated successfully.`, type: 'success', isShow: true });
    }
    catch (error) {
      setShowAlert({ title: "Alert", message: `Server Internal Error`, type: 'danger', isShow: true });
      console.log('apiErrror ' + error);
    }
  }

  const handleInputSystem = (e) => {
    let length = e.target.value.length;
    let element = document.getElementsByName(e.target.name)[0];
    if (length === 0) {
      element.style.boxShadow = '1px 1px 3px red, -1px -1px 3px red';
      setError({ errorFor: e.target.name, message: 'This field is required!' });
      setConfigurationData({ ...configurationData, [e.target.name]: e.target.value });
    }
    if (length > 0) {
      element.style = 'none';
      setError({ errorFor: '', message: '' });
      setConfigurationData({ ...configurationData, [e.target.name]: e.target.value });
    }
  }

  const updateSystemSetting = async () => {
    console.log('Updated system data ', configurationData); 
    try {
      const response = await axios({
        method: 'post',
        url: `${mainUrl}/api/updateSystemSettings`,
        data: {
          jwt_secret: configurationData.jwt_secret,
          encrypt_key: configurationData.encrypt_key,
          encrypt_iv: configurationData.encrypt_iv,
        },
        headers: {
          "content-type": "application/json",
          "authorization": `${token}`
        }
      });
      const data = response.data;
      // console.log("System " + JSON.stringify(data));
      setShowAlert({ title: "Alert", message: `System settings updated successfully.`, type: 'success', isShow: true });
    }
    catch (error) {
      setShowAlert({ title: "Alert", message: `Server Internal Error`, type: 'danger', isShow: true });
      console.log('apiErrror ' + error);
    }
  }

  const handleAlert = () => {
    setShowAlert({ title: '', message: '', type: '', isShow: false })
  }

  const handlesidebar = () => {
    if (togglesidebar) setTogglesidebar(false);
    else setTogglesidebar(true)
  }

  return (
    <div className='main-container'>
      <Sidebar togglevalue={togglesidebar} />
      <main>
        <div className='container-center'>
          {showAlert.isShow && <Alert title={showAlert.title} message={showAlert.message} type={showAlert.type} isShow={showAlert.isShow} handleAlert={handleAlert} />}

          <div onClick={handlesidebar}>
            {togglesidebar ? <div className='toggleicon'><AiOutlineMenu size={30} /> </div> : <div className='crossicon'><RxCross1 size={30} /></div>}
          </div>
          <h1 className='heading'> Settings </h1>
          <div id="form_container">
            <div id="account_form">
              <h4 className='form_heading'>Account Settings</h4>
              <form>
                <div className='form'>
                  <div className="form-group">
                    <label htmlFor="username" className='labletext'>Username</label>
                    <input className="txtbox" type="text" name="username" id="username" value={localStorage.getItem('username')} readOnly />
                  </div>
                  <div className="form-group">
                    <label htmlFor="admin_name" className='labletext'>Admin name</label>
                    <input className="txtbox" type='text' name="admin_name" id="admin_name" value={localStorage.getItem('admin_name')} readOnly/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="username" className='labletext'>Type</label>
                    <input className="txtbox" type="text" name="username" id="username" value={localStorage.getItem('type')} readOnly/>
                  </div>
                </div>
              </form>
            </div>


            <div id="configuration_form">
              <h4 className='form_heading'>Configuration Settings</h4>
              <div className='form'>
                <div className="form-group">
                  <label htmlFor="jwt_secret">JWT Secret</label>
                  <span className='icon eye' onClick={toggleEye}>
                  </span>
                  <input className="txtbox" type="text" name="jwt_secret" id="jwt_secret" value={configurationData.jwt_secret} onChange={handleInputSystem} readOnly={readOnly} />
                </div>
                <div className="form-group">
                  <label htmlFor="encrypt_key">Encrypt Key</label>
                  <input className="txtbox" type="text" name="encrypt_key" id="encrypt_key" value={configurationData.encrypt_key} onChange={handleInputSystem} readOnly={readOnly} />
                </div>
                <div className="form-group">
                  <label htmlFor="encrypt_iv">Encrypt IV</label>
                  <input className="txtbox" type="text" name="encrypt_iv" id="encrypt_iv" value={configurationData.encrypt_iv} onChange={handleInputSystem} readOnly={readOnly} />
                </div>
                <div className="btn_wrapper">
                { readOnly ? <Button name={"Edit"} onClick={() => { setReadOnly(false) }} /> : 
                  <Button name={"Save Changes"} disabled={false} onClick={updateSystemSetting} /> }
                </div>
              </div>
            </div>

            <div id="configuration_form">
              <h4 className='form_heading'>Twillio Settings</h4>
              <form>
                <div className='form'>
                  <div className="form-group">
                    <label htmlFor="acc_sid">Twillio Account SID</label>
                    <input className="txtbox" type="text" name="account_sid" id="acc_sid" value={twilioData.account_sid} onChange={handleInputTwilio} readOnly={readOnly} />
                  </div>
                  {error.errorFor === "account_sid" && <p style={{ color: 'red', textAlign: 'right' }} > {error.message} </p>}
                  <div className="form-group">
                    <label htmlFor="acc_keyid">Twillio Key SID</label>
                    <input className="txtbox" type="text" name="api_key_sid" id="acc_keyid" value={twilioData.api_key_sid} onChange={handleInputTwilio} readOnly={readOnly} />
                  </div>
                  {error.errorFor === "api_key_sid" && <p style={{ color: 'red', textAlign: 'right' }} > {error.message} </p>}
                  <div className="form-group">
                    <label htmlFor="key_secret">Twillio Key Secret</label>
                    <input className="txtbox" type="text" name="api_key_secret" id="key_secret" value={twilioData.api_key_secret} onChange={handleInputTwilio} readOnly={readOnly} />
                  </div>
                  {error.errorFor === "api_key_secret" && <p style={{ color: 'red', textAlign: 'right' }} > {error.message} </p>}
                  <div className="btn_wrapper">
                    {readOnly ? <Button name={"Edit"} onClick={() => { setReadOnly(false) }} /> : <Button name={"Save Changes"} className={"save_changes"} onClick={updateTwilio} />}
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      </main>
    </div>
  )
}

export default Setting;